/* ============================================
   Product Add-ons Carousel — ARCTA
   ============================================ */
(function () {
  'use strict';

  const SECTION_SELECTOR = '[data-product-addons]';
  const INIT_FLAG = 'data-addons-initialized';

  // ---------- Money formatting ----------
  function formatMoney(cents) {
    if (window.theme && window.theme.Currency && typeof window.theme.Currency.formatMoney === 'function') {
      return window.theme.Currency.formatMoney(cents, window.theme.moneyFormat || '€{{amount}}');
    }
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      const fmt = (window.theme && window.theme.moneyFormat) || '€{{amount}}';
      return Shopify.formatMoney(cents, fmt);
    }
    const amount = (cents / 100).toLocaleString('de-DE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    return amount + ' €';
  }

// ---------- Get current parent variant ID ----------
  function getCurrentParentVariantId() {
    // 1. Live-Quelle: hidden id-Input im Produkt-Form
    //    (wird von Motion bei jedem Variant-Wechsel aktualisiert)
    const productForm = document.querySelector(
      'form[action*="/cart/add"]:not([data-type="add-to-cart-cross-sell-form"])'
    );
    if (productForm) {
      const idInput = productForm.querySelector('[name="id"]');
      if (idInput && idInput.value) return parseInt(idInput.value, 10);
    }
    // 2. Fallback: serverseitig gerendertes Variant-JSON
    //    (statisch — nur beim Initial-Load korrekt)
    const currentEl = document.querySelector('[data-current-variant-json]');
    if (currentEl) {
      try {
        const v = JSON.parse(currentEl.value || currentEl.textContent);
        if (v && v.id) return v.id;
      } catch (e) {}
    }
    return null;
  }

  function getPreselectedForParent(parentVariantId) {
    if (!parentVariantId) return [];
    const el = document.querySelector('[data-addons-variant-map]');
    if (!el) return [];
    try {
      const map = JSON.parse(el.textContent);
      return map[String(parentVariantId)] || [];
    } catch (e) {
      return [];
    }
  }

  function getCardVariants(card) {
    const dataEl = card.querySelector('[data-addon-variants]');
    if (!dataEl) return null;
    try {
      return JSON.parse(dataEl.textContent);
    } catch (e) {
      return null;
    }
  }

  function applyVariantToCard(card, variant, updateSelect) {
    if (!card || !variant) return;
    const parentUrl = card.getAttribute('data-addon-parent-url') || '';
    const newUrl = parentUrl + (parentUrl.indexOf('?') >= 0 ? '&' : '?') + 'variant=' + variant.id;

    card.querySelectorAll('[data-addon-link]').forEach((a) => a.setAttribute('href', newUrl));

    const img = card.querySelector('[data-addon-image]');
    if (img && variant.image) {
      img.setAttribute('src', variant.image);
      if (variant.image_srcset) img.setAttribute('srcset', variant.image_srcset);
    }

    const priceEl = card.querySelector('[data-addon-price]');
    if (priceEl && typeof variant.price === 'number') {
      priceEl.textContent = formatMoney(variant.price);
    }

    const cmpEl = card.querySelector('[data-addon-price-compare]');
    if (cmpEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        cmpEl.textContent = formatMoney(variant.compare_at_price);
        cmpEl.removeAttribute('hidden');
      } else {
        cmpEl.setAttribute('hidden', '');
      }
    }

    if (updateSelect !== false) {
      const sel = card.querySelector('[data-addon-variant-select]');
      if (sel && sel.value !== String(variant.id)) {
        sel.value = String(variant.id);
      }
    }

    const btn = card.querySelector('[data-addon-add-btn]');
    const action = card.querySelector('.addon-card__action');
    if (variant.available) {
      if (btn) {
        btn.setAttribute('data-variant-id', String(variant.id));
        btn.removeAttribute('data-loading');
        btn.removeAttribute('data-success');
        btn.removeAttribute('data-error');
      } else if (action) {
        action.innerHTML =
          '<button type="button" class="addon-card__btn" data-addon-add-btn data-variant-id="' +
          variant.id +
          '" aria-label="In den Warenkorb">' +
          '<span class="addon-card__btn-content">' +
          '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>' +
          '</span>' +
          '<span class="addon-card__btn-spinner" aria-hidden="true">' +
          '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12a9 9 0 1 1-6.219-8.56"/></svg>' +
          '</span>' +
          '<span class="visually-hidden">In den Warenkorb</span>' +
          '</button>';
        attachBtnHandler(action.querySelector('[data-addon-add-btn]'));
      }
    } else {
      if (action) {
        action.innerHTML = '<span class="addon-card__sold-out">Ausverkauft</span>';
      }
    }
  }

  function syncAllAddons(scope) {
    const parentId = getCurrentParentVariantId();
    if (!parentId) return;

    const preselectedIds = getPreselectedForParent(parentId);
    if (!preselectedIds.length) return;

    const cards = (scope || document).querySelectorAll('[data-addon-multivariant="true"]');
    cards.forEach((card) => {
      const cardVariants = getCardVariants(card);
      if (!cardVariants) return;
      const cardVariantIds = cardVariants.map((v) => v.id);

      const matchedId = preselectedIds.find((id) => cardVariantIds.includes(id));
      if (matchedId) {
        const v = cardVariants.find((x) => x.id === matchedId);
        if (v) applyVariantToCard(card, v, true);
      }
    });
  }

  function attachSelectHandler(sel) {
    if (!sel || sel.hasAttribute('data-handler-attached')) return;
    sel.setAttribute('data-handler-attached', '');

    sel.addEventListener('change', () => {
      const card = sel.closest('[data-addon-card]');
      if (!card) return;
      const variants = getCardVariants(card);
      if (!variants) return;
      const newId = parseInt(sel.value, 10);
      const v = variants.find((x) => x.id === newId);
      if (v) applyVariantToCard(card, v, false);
    });
  }

  function attachBtnHandler(btn) {
    if (!btn || btn.hasAttribute('data-handler-attached')) return;
    btn.setAttribute('data-handler-attached', '');

    btn.addEventListener('click', (e) => {
      e.preventDefault();
      if (btn.getAttribute('data-loading') === 'true') return;

      const variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;

      btn.setAttribute('data-loading', 'true');

      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');

      const cartAddUrl =
        (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root
          : '/') + 'cart/add.js';

      fetch(cartAddUrl, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData,
      })
        .then((res) => {
          if (!res.ok) throw new Error('Cart add failed: ' + res.status);
          return res.json();
        })
        .then((item) => {
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { item } }));
          document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('product:added', { bubbles: true, detail: { item } }));
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true, detail: { item } }));

          if (window.theme && typeof window.theme.cart === 'object') {
            if (typeof window.theme.cart.buildCart === 'function') window.theme.cart.buildCart();
            if (typeof window.theme.cart.refresh === 'function') window.theme.cart.refresh();
            if (typeof window.theme.cart.open === 'function') window.theme.cart.open();
          }

          btn.removeAttribute('data-loading');
          btn.setAttribute('data-success', 'true');
          setTimeout(() => btn.removeAttribute('data-success'), 1800);
        })
        .catch((err) => {
          console.error('[product-addons] add to cart failed', err);
          btn.removeAttribute('data-loading');
          btn.setAttribute('data-error', 'true');
          setTimeout(() => btn.removeAttribute('data-error'), 2000);
        });
    });
  }

  // ---------- Carousel init ----------
  function initCarousel(section) {
    if (section.hasAttribute(INIT_FLAG)) return;
    section.setAttribute(INIT_FLAG, '');

    const viewport = section.querySelector('[data-addons-viewport]');
    const track = section.querySelector('[data-addons-track]');
    const dotsWrap = section.querySelector('[data-addons-dots]');
    const prevBtn = section.querySelector('[data-addons-prev]');
    const nextBtn = section.querySelector('[data-addons-next]');
    if (!viewport || !track) return;

    const slides = Array.from(track.querySelectorAll('.product-addons__slide'));
    if (slides.length === 0) return;

    // ---------- Overflow check ----------
    const checkOverflow = () => {
      if (track.scrollWidth > track.clientWidth + 4) {
        section.setAttribute('data-has-overflow', '');
      } else {
        section.removeAttribute('data-has-overflow');
      }
    };
    checkOverflow();
    window.addEventListener('resize', checkOverflow);

    // ---------- Find currently focused slide (leftmost visible) ----------
    function getCurrentSlideIndex() {
      const scrollLeft = track.scrollLeft;
      let closestIdx = 0;
      let closestDist = Infinity;
      slides.forEach((slide, i) => {
        const slideLeft = slide.offsetLeft - track.offsetLeft;
        const dist = Math.abs(slideLeft - scrollLeft);
        if (dist < closestDist) {
          closestDist = dist;
          closestIdx = i;
        }
      });
      return closestIdx;
    }

    function scrollToSlide(index) {
      const target = slides[Math.max(0, Math.min(slides.length - 1, index))];
      if (target) {
        track.scrollTo({
          left: target.offsetLeft - track.offsetLeft,
          behavior: 'smooth',
        });
      }
    }

    // ---------- Nav button state ----------
    function updateNavState() {
      if (!prevBtn || !nextBtn) return;
      const atStart = track.scrollLeft <= 2;
      const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      prevBtn.disabled = atStart;
      nextBtn.disabled = atEnd;
    }

    // ---------- Nav buttons ----------
    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        scrollToSlide(getCurrentSlideIndex() - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        scrollToSlide(getCurrentSlideIndex() + 1);
      });
    }

    track.addEventListener('scroll', updateNavState, { passive: true });
    updateNavState();

    // ---------- Dots ----------
    if (dotsWrap) {
      dotsWrap.innerHTML = '';
      if (slides.length > 1) {
        slides.forEach((_, i) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'product-addons__dot';
          dot.setAttribute('aria-label', `Gehe zu Slide ${i + 1}`);
          if (i === 0) dot.classList.add('is-active');
          dot.addEventListener('click', () => scrollToSlide(i));
          dotsWrap.appendChild(dot);
        });
      }
    }

    if (dotsWrap && 'IntersectionObserver' in window && slides.length > 1) {
      const dots = Array.from(dotsWrap.querySelectorAll('.product-addons__dot'));
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const idx = slides.indexOf(entry.target);
              if (idx >= 0) dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
            }
          });
        },
        { root: track, threshold: 0.55 }
      );
      slides.forEach((s) => observer.observe(s));
    }

    // ---------- Mouse drag (desktop) ----------
    if (window.matchMedia('(hover: hover)').matches) {
      let isDown = false, startX = 0, scrollStart = 0, moved = false;
      track.addEventListener('mousedown', (e) => {
        if (e.target.closest('button, a, select')) return;
        isDown = true; moved = false;
        startX = e.pageX; scrollStart = track.scrollLeft;
        track.classList.add('is-dragging');
      });
      track.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        const dx = e.pageX - startX;
        if (Math.abs(dx) > 4) moved = true;
        track.scrollLeft = scrollStart - dx;
      });
      const release = () => { if (!isDown) return; isDown = false; track.classList.remove('is-dragging'); };
      track.addEventListener('mouseup', release);
      track.addEventListener('mouseleave', release);
      track.addEventListener('click', (e) => {
        if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
      }, true);
    }

    section.querySelectorAll('[data-addon-add-btn]').forEach(attachBtnHandler);
    section.querySelectorAll('[data-addon-variant-select]').forEach(attachSelectHandler);

    syncAllAddons(section);
  }

  function initAll() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(initCarousel);
  }

  function setupParentListeners() {
    // Generisch: jede Input-/Select-Änderung im Produktbereich
    document.addEventListener('change', (e) => {
      if (!e.target) return;
      const inProductArea = e.target.closest(
        '[data-product-blocks], .product-single__meta, .product-section, form[action*="/cart/add"]'
      );
      // Nicht auf unsere eigenen Add-on-Selects reagieren
      const isAddonSelect = e.target.closest('[data-addon-card]');
      if (inProductArea && !isAddonSelect) {
        setTimeout(syncAllAddons, 50);
        setTimeout(syncAllAddons, 250); // Zweiter Versuch nachdem Motion das id-Input aktualisiert hat
      }
    });

    // Klicks auf Variant-Buttons / Labels
    document.addEventListener('click', (e) => {
      const variantBtn = e.target.closest(
        '[data-variant-button], .variant-input, .variant-input-wrap label, [data-variant-input]'
      );
      if (variantBtn) {
        setTimeout(syncAllAddons, 80);
        setTimeout(syncAllAddons, 300);
      }
    });

    // Theme-Custom-Events
    ['variantChange', 'variant:change', 'variantUpdate'].forEach((evt) => {
      document.addEventListener(evt, () => setTimeout(syncAllAddons, 10));
    });

    // Sicherheitsnetz: Polling der aktuellen Variant-ID.
    // Deckt alle Picker-Implementierungen ab, auch wenn Motion das
    // [name="id"] Input rein programmatisch (ohne Event) ändert.
    let lastParentVariantId = getCurrentParentVariantId();
    setInterval(() => {
      const currentId = getCurrentParentVariantId();
      if (currentId && currentId !== lastParentVariantId) {
        lastParentVariantId = currentId;
        syncAllAddons();
      }
    }, 400);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initAll();
      setupParentListeners();
    });
  } else {
    initAll();
    setupParentListeners();
  }

  document.addEventListener('shopify:section:load', (e) => {
    const sec = e.target.querySelector(SECTION_SELECTOR);
    if (sec) initCarousel(sec);
  });
})();